<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"/>
    <div class="topTip">
      <span class="f14 col_black mr20">批次：{{ planName }}</span>
      <span class="f14 col_black mr20">课程：{{ courseName }}</span>

      <span class="f14 col_black">科目：</span>
      <el-select v-model="subject" placeholder="请选择科目" class="mr20">
        <el-option :label="item.subCourseName" :value="item.subCourseId" v-for="item in subjectList" :key="item.subCourseId"></el-option>
      </el-select>

      <span class="f14 col_black mr20" v-show="singleAvgScore">单科平均分：<span style="color:#67C2A3;">{{singleAvgScore}}</span> <span>分</span> </span>

    </div>
    <div class="searchBox">
      <ots-refer class="mb20" :selectList="selectList" :request-form="stuSelectParams" @search="getStuList"/>
    </div>

    <div class="tableBorder">
      <!-- 表格 -->
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
        :batchOperBtn="batchOperBtn"
      ></ots-table-group-new>
    </div>

  </div>
</template>
<script>
import { getSubCourseListAPI, getSubCourseStudentScoreListAPI, getExamCheckStateFn, exportSubCourseStudentScoreListAPI } from "@/http/modules/examSet/score";
import { getPlaceInfofn } from "@/http/modules/baseSet/majorCourse";
export default {
  name: "singleGrades",
  data() {
    return {
      mainTopBtnList: [
        { title: "导出", fn: this.exportScore }
      ],
      selectList: [
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证/证件号",
          requestKey: "searchKey",
        },
        {
          title: "教学点",
          type: "select",
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
          data: [],
        },
        {
          title: "考试状态",
          type: "select",
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "分数段",
          type: "inputInterval",
          placeholder: "例如0-59",
          requestKey: "minScore",
          requestKeySecond: "maxScore",
        },

      ],
      stuSelectParams: {
        searchKey: "",
        stationId: "",
        placeId: "",
        checkState: "",
        minScore: "",
        maxScore: "",
        planId: "",
        subCourseId: "",
      },

      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          fixed: "left"
        },
        {
          title: "科目",
          prop: "subCourseName",
          fixed: "left",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
          fixed: "left",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "成绩",
          prop: "score",
        },
        {
          title: '',
          prop: '',
          width: '1'
        }
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
      stuListParams: {
        planId: "",
        page: 1,
        size: 10,
      },

      planName: "",
      courseName: "",
      batchOperBtn: [
        {
          title: "返回",
          click: () => { this.$router.go(-1) },
        },
      ],
      // 科目
      subject: '',
      // 科目列表
      subjectList: [],
      // 单科平均分
      singleAvgScore: '',
    };
    
  },
  watch: {
    "stuSelectParams.planId": function (val) {
      this.stuSelectParams.placeId = "";
      this.stuSelectParams.stationId = "";
    },

    // 函授站（教学点）切换后重新获取考点
    "stuSelectParams.stationId": function () {
      this.getPlaceListFn();
    },

    // 根据科目选择展示 '单科平均分'
    subject: function (val) {
      if (val) {
        let subject = this.subjectList.find(item => item.subCourseId == val);
        this.singleAvgScore = subject.score;
      } else {
        this.singleAvgScore = '';
      }
    }

  },
  created() {
    this.planName = this.$route.query.planName;
    this.courseName = this.$route.query.courseName;
    this.initData();
    this.getExamStatus();
  },

  mounted() {
    // 获取科目列表
    this.getSubjectList();
  },

  methods: {
    // 获取科目列表
    async getSubjectList() {
      let { planId, courseId } = this.$route.query;
      const { data } = await getSubCourseListAPI({planId, courseId});
      this.subjectList = [...data];
    },

    //获取考试状态下拉数据
    getExamStatus() {
      getExamCheckStateFn().then((res) => {
        if (res.code === 1) {
          this.$set(this.selectList[3], "data", res.data);
        }
      });
    },

    // 初始化数据
    async initData() {
      this.stuSelectParams.planId = this.$route.query.planId;
      this.stuSelectParams.courseId = this.$route.query.courseId;
      const data = await this.mixin_getSelectStation();
      this.selectList[1].data = [...data];
    },

    // 获取考点
    async getPlaceListFn() {
      let params = {
        planId: this.stuSelectParams.planId,
        stationIds: this.stuSelectParams.stationId
      }
      const { data } = await getPlaceInfofn(params);
      this.selectList[2].data = [...data];
    },
    
    // 查询单科成绩
    async getStuList(page) {
      if (!this.subject) {
        this.$message.warning('请选择科目！');
        return;
      }

      let params = Object.assign(this.stuListParams, this.stuSelectParams);
      params.subCourseId = this.subject;

      // let reg = /(^[0-9]\d*$)/;
      // if (!reg.test(params.minScore) || !reg.test(params.maxScore)) {
      //   this.$message.warning('分数段请输入不小于0的整数！');
      //   return;
      // }

      if (!page) { params.page = 1 };

      const { data } = await getSubCourseStudentScoreListAPI(params);
      this.tableData = data.records;
      this.pagination.total = data.total;
    },

    // 导出
    async exportScore() {
      let params = Object.assign(this.stuListParams, this.stuSelectParams);
      params.subCourseId = this.subject;
      const {code, data} = await exportSubCourseStudentScoreListAPI(params);
      if (code) {
        window.open(data);
      }
    },

    changeSize(num) {
      this.stuListParams.size = num;
      this.getStuList();
    },

    changePage(p) {
      this.stuListParams.page = p;
      this.getStuList(true);
    },
  },
};
</script>
<style lang="less" scoped>
.searchBox /deep/ .el-form-item__label {
  min-width: 120px;
  width: auto !important;
}
.topTip {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #ebf0fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}
.tableBorder {
  background-color: #fff;
  border-radius: 8px;
}
.searchBox {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}
</style>
